import {
  CreditCardCheck,
  Loading02,
  User03,
  UsersCheck,
  UsersMinus
} from "untitledui-js-base";

export enum AccountStatusVariant {
  Active = "active",
  Pending = "pending",
  Unsubscribed = "unsubscribed",
  NeedToReport = "need_to_report",
  All = "all",
  Rejected = "rejected",
  PendingIDV = "pending_IDV",
  PendingLeaseVerification = "pending_lease_verification",
  PendingLandlordVerification = "pending_landlord_verification",
  PendingOptIn = "pending_opt_in",
  PendingOptOut = "pending_opt_out"
}

export enum CaseStatusVariant {
  PendingOptIn = "pending_opt_in",
  PendingOptOut = "pending_opt_out"
}

export enum PaymentStatuses {
  NO_DATA = "reject",
  PAID_ON_TIME = "verify",
  DELINQUENCY = "delinquency"
}

export const getEmptyState = (tab: AccountStatusVariant, isSdk: boolean) => {
  const customers = isSdk ? "Users" : "Renters";
  switch (tab) {
    case AccountStatusVariant.Active:
      return {
        title: `${customers} with active accounts will appear here`,
        subtitle: `${customers} with active accounts are subscribed to BoomReport, and their accounts are active for rent reporting`,
        icon: UsersCheck
      };
    case AccountStatusVariant.NeedToReport:
      return {
        title:
          "Rent payments that require a manual status report will appear here",
        icon: CreditCardCheck
      };
    case AccountStatusVariant.Pending:
      return {
        title: `${customers} with pending accounts will appear here`,
        subtitle: `${customers} with pending accounts are subscribed to BoomReport, but their account is not active yet for rent reporting`,
        icon: Loading02
      };
    case AccountStatusVariant.Unsubscribed:
      return {
        title: `Unsubscribed ${customers.toLocaleLowerCase()} will appear here`,
        subtitle: isSdk
          ? ""
          : '"Unsubscribed renters" refers to renters who have chosen to unsubscribe from rent reporting or have been unsubscribed by you within the Boom platform',
        icon: UsersMinus
      };
    case AccountStatusVariant.All:
      return {
        title: isSdk
          ? "Rent reporting subscribers will appear here"
          : "Get started",
        subtitle: isSdk
          ? ""
          : "Subscribe renters to start reporting their rent payments",
        icon: User03
      };
    default:
      return { title: "No results found" };
  }
};

export enum RvStatus {
  Verified = "verified",
  ManualVerificationNeeded = "manual_verification_needed",
  PendingConfirmation = "pending_confirmation",
  PendingVerification = "pending_verification"
}

export enum PendingIdentityVerificationStatus {
  Pending = "identity_verification_pending",
  Rejected = "identity_verification_rejected",
  Skipped = "identity_verification_skipped",
  Verified = "identity_verification_verified"
}

export enum LeaseVerificationStatus {
  Verified = "lease_verification_verified",
  Rejected = "lease_verification_rejected",
  Pending = "lease_verification_pending"
}

export enum LandlordVerificationStatus {
  Verified = "landlord_verification_verified",
  Rejected = "landlord_verification_rejected",
  Pending = "landlord_verification_pending"
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc"
}
